import React from "react";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";

// Import styled components
import {
  MovieDetailsContainer,
  Headlining,
  DetailsDataContainer,
  AgeRestriction,
  ClockIcon,
  Duration,
  DetailsContainer,
  DetailsLabel,
  FacebookLink,
  VideoContainer,
  ImageContainer,
} from "./MovieInfoStyle";
import { Movies } from "../../models/Movies";

const MovieInfo = ({ movie, isShowVideo, isScreenMode }: Props) => {
  return (
    <>
      <MovieDetailsContainer>
        {isShowVideo ? (
          <Headlining isScreenMode={isScreenMode}>{movie.name}</Headlining>
        ) : isScreenMode ? (
          <>
            <Headlining isScreenMode={isScreenMode}>{movie.name}</Headlining>
          </>
        ) : (
          <>
            <Link to={`/o-filmu/${movie.slug}`}>
              <Headlining isScreenMode={isScreenMode}>{movie.name}</Headlining>
            </Link>
          </>
        )}
        <DetailsDataContainer
          isDirectionRow={true}
          isShowBorder={true}
          gridArea={""}
          isScreenMode={isScreenMode}
        >
          <AgeRestriction isScreenMode={isScreenMode}>
            {movie.age}+
          </AgeRestriction>
          <ClockIcon isScreenMode={isScreenMode} />
          <Duration isScreenMode={isScreenMode}>
            {movie.duration} minuta
          </Duration>
        </DetailsDataContainer>
        <DetailsDataContainer
          isDirectionRow={false}
          isShowBorder={true}
          gridArea={""}
          isScreenMode={isScreenMode}
        >
          <DetailsContainer>
            <DetailsLabel isBold={true}>Glumci:</DetailsLabel>
            <DetailsLabel isBold={false}>{movie.actors}</DetailsLabel>
          </DetailsContainer>
          <DetailsContainer>
            <DetailsLabel isBold={true}>Redatelj:</DetailsLabel>
            <DetailsLabel isBold={false}>{movie.director}</DetailsLabel>
          </DetailsContainer>
          <DetailsContainer>
            <DetailsLabel isBold={true}>Žanr:</DetailsLabel>
            <DetailsLabel isBold={false}>{movie.genre}</DetailsLabel>
          </DetailsContainer>
          <DetailsContainer>
            <DetailsLabel isBold={true}>Jezik:</DetailsLabel>
            <DetailsLabel isBold={false}>{movie.language}</DetailsLabel>
          </DetailsContainer>
          <DetailsContainer>
            <DetailsLabel isBold={true}>Država:</DetailsLabel>
            <DetailsLabel isBold={false}>{movie.state}</DetailsLabel>
          </DetailsContainer>
          <DetailsContainer>
            <DetailsLabel isBold={true}>Godina:</DetailsLabel>
            <DetailsLabel isBold={false}>{movie.year}</DetailsLabel>
            <FacebookLink
              href="https://www.facebook.com/kinokrizevci"
              target="_blank"
            />
          </DetailsContainer>
        </DetailsDataContainer>
        {isShowVideo ? (
          <VideoContainer>
            <ReactPlayer
              width="100%"
              height="100%"
              controls
              url={movie.video_url}
            />
          </VideoContainer>
        ) : (
          <></>
        )}
      </MovieDetailsContainer>
      <ImageContainer
        bgImage={movie.poster_image_url}
        isDetailMovie={isShowVideo}
        isScreenMode={isScreenMode}
      />
    </>
  );
};

export default MovieInfo;

type Props = {
  movie: Movies;
  isShowVideo: boolean;
  isScreenMode: boolean;
};
